import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as echarts from 'echarts';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';


@Component({
  selector: 'app-dashboard-details-popup',
  templateUrl: './dashboard-details-popup.component.html',
  styleUrls: ['./dashboard-details-popup.component.scss'],
})
export class DashboardDetailsPopupComponent implements OnInit {
  moduleName: any;
  action: any;
  buttonColorName: any;
  subModuleButtonColor: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserId: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  selectedYear: any;
  selectedMonth: any;
  activeEmployeeList: any = [];
  goalSettingList: any;
  type: any;
  popupName: any;
  loggedInCompanyHRID:any;
  exitedEmployeeRecord: any;
  goalReviewStatusList: any = [];
  managerApprovalData: any = [];
  myGoalSettingStatus: any = [];
  myGoalReviewStatus: any = [];
  myApprovedStatus: any = [];
  totalCount: any = 0;
  compnayScoreNameOfperson: any = [];
  iconBackgroundColor: string = '';
  selectedIcon: any = '';
  year: any;
  month: any;
  managerData: any = [];
  companyScoreMonths: any = [];
  kpiScoreData: any = [];
  highcharts: typeof Highcharts = Highcharts;

  barChartShow: boolean = true;
  pieChartShow: boolean = false;
  areaChartShow: boolean = false;
  lineChartShow: boolean = false;

  kpiScorePieData: any = [];
  employeeData: any = [];
  isToggleOn: boolean = true;
  fisrtDashboardColor: any = '#F6921E';
  secondDashboardColor: any = '#393186';
  dashboardColorName: any;
  graphData:any;
  ytdScore:any;
  loggedInCompanyMDID:any;
  currentTabName:any;
  downloadGraphID:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public sharedService: SharedService,
    public dialogRef: MatDialogRef<DashboardDetailsPopupComponent>, private fb: FormBuilder, private dialog: MatDialog, private loadingService: LoaderService,
    private config: Config, private httpService: HttpService, private encryptionService: EncryptionService,
    private route: ActivatedRoute, private pdfDownload:DownloadAsPdfService, public mobileResponsiveService: MobileResponsiveService) { }


  ngOnInit() {
    this.currentTabName = this.data?.currentTabName;   
    console.warn("current tab", this.currentTabName);
    
    this.action = this.data?.action;
    this.moduleName = this.data?.moduleName;
    this.selectedMonth = this.data?.month;
    this.selectedYear = this.data?.year;
    this.popupName = this.data?.popupName;
    this.month = this.data?.month;
    this.year = this.data?.year;
    this.compnayScoreNameOfperson = this.data?.name;
    this.graphData = this.data?.graphData;
    this.ytdScore = this.data?.ytdScore;
    this.downloadGraphID = this.data?.downloadGraphID
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = Number(sessionStorage.getItem('loggedInUserId'));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.dashboardColorName = sessionStorage.getItem('dashboardColorName');
    if(sessionStorage.getItem('loggedInCompanyMDID')){
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    this.loggedInCompanyHRID = sessionStorage.getItem('userCompanyHr')
    
    this.dashboardColorName = this.dashboardColorName?.split(',');
    if (this.dashboardColorName.length != 0) {
      this.fisrtDashboardColor = this.dashboardColorName[0];
    }
    if (this.dashboardColorName.length > 1) {
      this.secondDashboardColor = this.dashboardColorName[1];
    }

    this.getDashboardList();
    this.getCompanyScoreCard();
    this.employeeScoreCard();
  }


  ionViewWillEnter() {

  }

  searchEmployee:any;
  // onEmployeeSearch(data:any){
  //   var search = ''
  //   this.searchEmployee = data;
  //   if (data == '') {
  //     this.searchEmployee = null;
  //     this.activeEmployeeList= []
  //     return;
  //   }
  //   if (data.length > 1) {
  //     setTimeout(() => {
  //       search = data;
  //       if (search.length == data.length) {
  //         setTimeout(() => {
  //           this.getDashboardList();
  //         },
  //           500);
  //       }else{

  //       }
  //     },
  //       1500);
  //   }
  // }

  onEmployeeSearch(data: any) {
    console.warn("search input", data);
    if (!data || data.trim() === '') {
      this.searchEmployee = null;
      this.getDashboardList();
      this.activeEmployeeList = [];
      // this.totalCount
      return;
    }
    this.searchEmployee = data;
    if (data.length > 0) {
      setTimeout(() => {
        if (data === this.searchEmployee) {
          this.getDashboardList();
        }
      }, 1500);
    }
  }

  getDashboardList() {
    
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'HR Admin') {
      id= this.loggedInCompanyMDID;
    }else{
      id = this.loggedInUserId
    }
    let request = {}
 
    if(this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'HR Admin') {
 request = {
        "companyId": this.loggedInUserCompanyID,
        "month": this.selectedMonth,
        "name": this.moduleName,
        "search": this.searchEmployee,
        "type": this.type,
        "userId": id,
        "year": this.selectedYear,
        "loggedInUserRole": this.loggedInUserRole
      };
    }else{
      
      request = {
        
        "companyId": this.loggedInUserCompanyID,
        "month": this.selectedMonth,
        "name": this.moduleName,
        "search": this.searchEmployee,
        "type": this.type,
        "userId": this.loggedInUserId,
        "year": this.selectedYear,
        "loggedInUserRole": this.loggedInUserRole
      };
    }
    this.httpService.callPostService(this.config.getDashboardList, request).subscribe((data: any) => {
      this.activeEmployeeList = [];
      this.exitedEmployeeRecord = [];
      this.goalReviewStatusList = [];
      this.managerApprovalData = [];
      this.myGoalSettingStatus = [];
      this.goalSettingList = [];
      this.myGoalReviewStatus = [];
      this.myApprovedStatus = [];

      if (this.moduleName == 'Active Employees') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'Exited Employees') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'Goal Setting Status') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'Goal Review Status') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'Manager Approval Status') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'My Goal Setting Status') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'My Goal Review Status') {
        this.totalCount = data.data.totalElements;
      } if (this.moduleName == 'My Approved Status') {
        this.totalCount = data.data.totalElements;
      }
      if(this.currentTabName != 'myhome' || this.loggedInUserRole == 'Employee' || this.searchEmployee != null){
        this.activeEmployeeList = data?.data?.content;
      }
      this.goalSettingList = data?.data?.content;
      this.goalReviewStatusList = data?.data?.content;
      this.managerApprovalData = data?.data?.content;
      this.exitedEmployeeRecord = data?.data?.content;
      this.myGoalSettingStatus = data?.data?.content;
      this.myGoalReviewStatus = data?.data?.content;
      this.myApprovedStatus = data?.data?.content;
    })
  }

  onClickGoToEmployeeMasterPage(id:any){
    if(this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'HR Admin'){
        if(this.currentTabName == 'myhome'){
          this.router.navigate(['/home/hrportal/employeemaster', { id: id, operation: 'Show' }]);
          this.dialogRef.close(); 
        }
      }
  }

  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;
    if (event?.checked == true) {
      this.type = 'Complete';
      if ((this.moduleName == 'My Approved Status' || this.moduleName == 'Manager Approval Status') && event?.checked == true) {
        this.type = 'Approved';
      }
      this.getDashboardList()
    } else if (event?.checked == false) {
      this.type = 'Incomplete';
      if ((this.moduleName == 'My Approved Status' || this.moduleName == 'Manager Approval Status') && event?.checked == false) {
        this.type = 'Rejected';
      }
      this.getDashboardList()
    }
  }

  onClickIcon(value: any) {
    this.barChartShow = value === 'Bar';
    this.lineChartShow = value === 'Line';
    this.pieChartShow = value === 'Pie';
    this.areaChartShow = value === 'Area';

    // if (this.barChartShow) {
    //   this.scoreBarChart();
    // } else if (this.lineChartShow) {
    //   this.scoreLineChart();
    // } else if (this.pieChartShow) {
    //   this.scoreDonutChart();
    // } else if (this.areaChartShow) {
    //   this.scoreAreaChart();
    // }
  }

  getIconClass(iconType: string) {
    return {
      'selected-icon': this.selectedIcon === iconType
    };
  }

  employeeScoreCard() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'HR Admin') {
      id= this.loggedInCompanyMDID;
    }else{
      id = this.loggedInUserId
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "month": this.month,
      "name": null,
      "type": "",
      "userId": id,
      "year": this.selectedYear,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.companyScoreCard, request).subscribe((data: any) => {
      this.companyScoreMonths = data.data.months.map((month: any) => ({ months: month }));
      // Get employee data
      this.employeeData = [];
      for (let i = 0; i < data.data.response.length; i++) {
        const employeeResponse = data.data.response[i];
        const kpiScores = employeeResponse.response.map((kpi: any) => ({
          kpiScore: kpi.kpiScore,
          month: kpi.month
        }));

        this.employeeData.push({
          employeeName: `${employeeResponse.firstName} ${employeeResponse.lastName}`,
          ytdScore: employeeResponse.ytd,
          kpiScores: kpiScores
        });
      }
    });
  }
  chartCompanyScoreCard: echarts.ECharts | undefined;
  chartOptionsCompanyScoreCard: any = {
    line: {},
    bar: {},
    pie: {},
    area: {}
  };
  graphDataToShow:any=[];
  getCompanyScoreCard() {
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": this.month,
    //   "name": null,
    //   "type": "LoggedUser",
    //   "userId": this.loggedInUserId,
    //   "year": this.selectedYear
    // }
    // this.httpService.callPostService(this.config.companyScoreCard, request).subscribe((data: any) => {
    //   this.companyScoreMonths = [];
    //   this.managerData = [];
    //   this.kpiScoreData = [];
    this.graphDataToShow = [];
      this.graphData?.forEach((ele:any)=>{
        let obj={
          name: this.sharedService.transform(ele.months),
          value: ele.kpiScore
        }
        this.graphDataToShow.push(obj)
      })
      this.graphDataToShow.push({name: 'YTD',value:this.ytdScore}) 
      
      // this.initChart()
      this.chartOptionsCompanyScoreCard.line = this.getLineChartOptions(this.graphDataToShow);
      this.chartOptionsCompanyScoreCard.bar = this.getBarChartOptions(this.graphDataToShow);
      this.chartOptionsCompanyScoreCard.pie = this.getPieChartOptions(this.graphDataToShow);
      this.chartOptionsCompanyScoreCard.area = this.getAreaChartOptions(this.graphDataToShow);
      // Set the chart to default type initially
      this.setChartType('line');
    // });
  }
  ngAfterViewInit() {
    this.initChart();
  }
  kpiScoreSummaryGraphType: any = 'line'
  setChartType(type: string) {
    this.kpiScoreSummaryGraphType = type;
    const dom = document.getElementById('companyscoreTrendReport') as HTMLDivElement;
    setTimeout(() => {
    this.chartCompanyScoreCard = echarts?.init(dom);
    if (this.chartCompanyScoreCard) {
      this.chartCompanyScoreCard.setOption(this.chartOptionsCompanyScoreCard[type]);
      if (type == 'pie') {
        this.getPieChartOptions(this.graphDataToShow);
      } if (type == 'line') {
        this.getLineChartOptions(this.graphDataToShow);
      } if (type == 'bar') {
        this.getBarChartOptions(this.graphDataToShow);
      } if (type == 'area') {
        this.getAreaChartOptions(this.graphDataToShow);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartCompanyScoreCard);
    }, 800);
  }
  initChart() {
    // const dom = document.getElementById('companyscoreTrendReport') as HTMLDivElement;
    // this.chartCompanyScoreCard = echarts.init(dom);
    this.setChartType('line'); // Set default chart type
  }
  getLineChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value' },
      series: [{ name: 'Score', type: 'line', data: data.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
      label: { show: true, position: 'top',fontSize: 9  } }]
    };
  }
  getBarChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value' },
      series: [{ name: 'Score', type: 'bar', data: data.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
      label: { show: true, position: 'top',fontSize: 9  } }]
    };
  }
  getPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: 0
      },
      series: [
        {
          name: 'Range',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptions(data: any): echarts.EChartsOption {
    return {
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', boundaryGap: false, data: data.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value' },
      series: [{ areaStyle: {}, name: 'Score', type: 'line', data: data.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
      label: { show: true, position: 'top',fontSize: 9  } }]
    };
  }
  exportDashboardListExcel() {
    var id;
    if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'HR Admin') {
      id= this.loggedInCompanyMDID;
    }else{
      id = this.loggedInUserId
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "month": this.selectedMonth,
      "name": this.moduleName,
      "type": this.type,
      "userId": id,
      "year": this.selectedYear,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.exportDashboardListExcel, request).subscribe((data: any) => {
      if(data?.fileUrl!=null){
        var fileName = data?.fileUrl?.split(environment.downloadURL)
        saveAs(data?.fileUrl, fileName[1]); 
      }
    })
  }
  pmsDashboardGraphDownloadScoreTrend(){
    this.pdfDownload.PMSGraphPDFDownload(
      'companyscoreTrendReport', // chartId
      null, // tableId
      'Score Trand', // Title
      null, // Year
      null, // Month
      this.compnayScoreNameOfperson, // Employee name
      null, // Kpi
      null //selectedUom
    );
    // var reportType = 'Table';
    // var loggedUser = 'LoggedUser';
    // var id;
    // if(this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee'){
    //   id = this.loggedInUserId
    // }
    // if(this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
    //   || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD'){
    //   id= this.loggedInCompanyMDID
    // }
    // if(this.kpiScoreSummaryGraphType == 'bar'){
    //   reportType ='Bar Graph'
    // }
    // if(this.kpiScoreSummaryGraphType == 'line'){
    //   reportType ='Line Graph'
    // }
    // if(this.kpiScoreSummaryGraphType == 'area'){
    //   reportType ='Area Graph'
    // }
    // if(this.kpiScoreSummaryGraphType == 'pie'){
    //   reportType ='Donut Graph'
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "month": null,
    //   "name": null,
    //   "type": loggedUser,
    //   "userId": this.downloadGraphID,
    //   "fromYear": this.year,
    //   "loggedInUserRole": this.loggedInUserRole,
    //   "reportName": 'ScoreTrend',
    //   "reportType": reportType,
    // }
    // this.httpService.callPostService(this.config.pmsDashboardGraphDownload, request).
    // subscribe((data: any) => {

    // })
  }
}
